import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LAUNCH_ROUTES = new Set([
  'brand.launch',
  'admin.launch',
  'admin.launch.brand',
])

export const checkLaunchFeatureFlag: HermesGuardFn = async (to) => {
  if (!LAUNCH_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.launchDashboard')) {
    if (to.name === 'brand.launch') {
      // Keep the query so an embedded view (`embed=1`, e.g. Hercules' Launch
      // tool iframe) stays chrome-less after the fallback redirect.
      return {
        name: 'brand.home',
        params: { brandId: to.params.brandId },
        query: to.query,
      }
    }
    return { name: 'brands' }
  }

  return undefined
}
